import { render, staticRenderFns } from "./WindowTokenMenuFragment.vue?vue&type=template&id=864e8b36&scoped=true&"
import script from "./WindowTokenMenuFragment.vue?vue&type=script&lang=js&"
export * from "./WindowTokenMenuFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864e8b36",
  null
  
)

export default component.exports